export * from './src/ngx-uploader/module/ngx-uploader.module';
export * from './src/ngx-uploader/classes/ngx-uploader.class';
export * from './src/ngx-uploader/directives/ng-file-select.directive';
export * from './src/ngx-uploader/directives/ng-file-drop.directive';



//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/node_modules/ngx-uploader/lib/index.js
// module id = ../../../../ngx-uploader/lib/index.js
// module chunks = vendor